import { useCallback, useContext } from "react";
import { SmbToastContext } from "../../context/SmbTabsContext";
import axios from "axios";
import { TBillImportData } from "../../components/Importer/Bill/hooks/useBillImporter";

export const useQsBillImporterProcess = (callback: () => void) => {
  const { addToast } = useContext(SmbToastContext);

  return useCallback(
    async (data: TBillImportData[]) => {
      try {
        const response = await axios.post<{ errors: string[] }>(
          "/admin/import/qs-bill/",
          {
            data,
          }
        );

        if (addToast && response.data.errors) {
          for (const message of response.data.errors) {
            addToast({
              message,
              intent: "error",
              autoClose: 0,
            });
          }
        }

        callback();
      } catch (err) {}
    },
    [callback, addToast]
  );
};
